import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 30px;
`;

const UL = styled.ul`
  margin: 0;
  list-style: none;
  padding-left: 2rem;
`;

const IncomeList = ({ children }) => (
  <Container>
    <UL>{children}</UL>
  </Container>
);

IncomeList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default IncomeList;
